// extracted by mini-css-extract-plugin
export var cardHeader = "_f7-1";
export var contentCard = "_f7-0";
export var headerActions = "_f7-3";
export var reorderHandle = "_f7-5";
export var titleArea = "_f7-2";
export var titleAreaWithHandle = "_f7-4";